import React from 'react';
import './Notification.css';

export default function Notification({ notification }) {
  if (!notification) return null;
  const icons = { success: '✓', achievement: '◆', levelup: '▲', error: '✕' };
  return (
    <div className={`notification notification-${notification.type} animate-in`} key={notification.id}>
      <span className="notif-icon">{icons[notification.type] || '✓'}</span>
      <span className="notif-msg">{notification.msg}</span>
    </div>
  );
}
